import { createContext } from 'react'

type ContextState = {
  id: string
  readOnly: boolean
  disabled: boolean
}

export const CustomContext = createContext<ContextState>({
  id: '',
  readOnly: false,
  disabled: false
})
